import lodash from 'lodash'
import React from 'react'
import styled from 'styled-components'

import Field from '../../../../../../../1stlog-ui/src/components/Field'
import {
  composeValidators,
  required,
} from '../../../../../../../1stlog-ui/src/components/Field/Validation'
import { useForm } from '../../../../../../../1stlog-ui/src/components/Form'
import TypeAhead from '../../../../../../../1stlog-ui/src/components/TypeAhead'
import { request } from '../../../../../../../1stlog-ui/src/utils'
import { useProductSettings } from '../../../../Products'
import useOrderEntry from '../../../../useOrderEntry'
import { renderOption } from './TypeAheadOption'

const Wrapper = styled.div``

const UnNumber = (props) => {
  const { name } = props

  const { hazmatUrl } = useOrderEntry()

  const form = useForm()

  const { hazmatAllowedUnNumberList, hazmatAllowedUnNumberRanges } =
    useProductSettings()

  const setValues = (values) => {
    const {
      unNumber,
      description,
      transportCategory,
      packagingGroup,
      classCode,
      tunnelLimitation,
      environmentalHazardProposed,
      limitedQuantityAllowed,
      adrRulesDontApply,
      adrRulesDontApplyDescription,
      limitedQuantityDetails,
      transportForbiddenByLaw,
      transportForbiddenByTenantRules,
      allowedFor1000PointTransport,
      exceptedQuantity,
      pointMultiplicator,
      specialInstructions,
      hazardLabels,
    } = values
    const classKey = values?.class?.key
    const formValues = {
      unNumber,
      description,
      transportCategory,
      packagingGroup,
      class: classKey,
      tunnelLimitation,
      classCode: lodash.get(lodash.first(classCode), 'key'),
      environmentalHazard: environmentalHazardProposed ? true : undefined,
      limitedQuantityAllowed,
      adrRulesDontApply,
      adrRulesDontApplyDescription,
      limitedQuantityDetails,
      transportForbiddenByLaw,
      transportForbiddenByTenantRules,
      exceptedQuantity,
      pointMultiplicator,
      allowedFor1000PointTransport,
      specialInstructions,
      identificationMarkings: hazardLabels,
    }

    setTimeout(
      () =>
        form.batch(() => {
          lodash.forEach(formValues, (value, key) =>
            form.change(`${name}.${key}`, value),
          )
        }),
      0,
    )
  }

  return (
    <Wrapper>
      <Field
        name="unNumber"
        label="UN-Nr."
        validate={composeValidators(
          required,
          mustBeInAllowedUnNumberList(
            hazmatAllowedUnNumberList,
            hazmatAllowedUnNumberRanges,
          ),
        )}
        required
      >
        <TypeAhead
          minLength={2}
          onSetValues={setValues}
          renderOption={renderOption}
          requestOptions={requestOptions({
            hazmatAllowedUnNumberList,
            hazmatAllowedUnNumberRanges,
            hazmatUrl,
          })}
        />
      </Field>
    </Wrapper>
  )
}

export default UnNumber

function mustBeInAllowedUnNumberList(
  allowedUnNumberList,
  hazmatAllowedUnNumberRanges,
) {
  return (value) => {
    // If both lists are empty, return null (always pass)
    if (
      (lodash.isEmpty(allowedUnNumberList) ||
        !lodash.isArray(allowedUnNumberList)) &&
      (lodash.isEmpty(hazmatAllowedUnNumberRanges) ||
        !lodash.isArray(hazmatAllowedUnNumberRanges))
    ) {
      return null
    }

    // Check if the value is in the allowed list
    const inList =
      lodash.isArray(allowedUnNumberList) &&
      !lodash.isEmpty(allowedUnNumberList) &&
      allowedUnNumberList.includes(value)

    // Check if the value falls within any allowed range
    const inRange =
      lodash.isArray(hazmatAllowedUnNumberRanges) &&
      !lodash.isEmpty(hazmatAllowedUnNumberRanges) &&
      hazmatAllowedUnNumberRanges.some((range) => {
        const start = parseFloat(range.un_start)
        const end = parseFloat(range.un_end)
        const num = parseFloat(value)
        return num >= start && num <= end
      })

    // If either list has entries but the value fails both checks, return error
    if (!inList && !inRange) {
      return 'UN-Nummer darf nicht verwendet werden'
    }

    return null
  }
}

function requestOptions({
  hazmatAllowedUnNumberList,
  hazmatAllowedUnNumberRanges,
  hazmatUrl,
}) {
  console.log(hazmatAllowedUnNumberRanges)
  return async (searchBy = 'description', value) => {
    const body = {
      [searchBy === 'description' ? 'text' : searchBy]: value,
    }

    let { data } = await request({
      method: 'post',
      url: hazmatUrl,
      data: body,
    })

    // Only filter if at least one of the conditions is provided
    const hasList =
      lodash.isArray(hazmatAllowedUnNumberList) &&
      !lodash.isEmpty(hazmatAllowedUnNumberList)
    const hasRanges =
      lodash.isArray(hazmatAllowedUnNumberRanges) &&
      !lodash.isEmpty(hazmatAllowedUnNumberRanges)

    if (hasList || hasRanges) {
      data = lodash.filter(data, (h) => {
        const unNumber = lodash.get(h, 'unNumber')

        // Check if unNumber is in the allowed list (if provided)
        const inAllowedList = hasList
          ? hazmatAllowedUnNumberList.includes(unNumber)
          : false

        // Check if unNumber falls within any of the allowed ranges (if provided)
        const inAllowedRange = hasRanges
          ? hazmatAllowedUnNumberRanges.some((range) => {
              // Convert string representations to numbers for proper comparison
              const start = parseInt(range.un_start)
              const end = parseInt(range.un_end)
              const num = parseInt(unNumber)
              return num >= start && num <= end
            })
          : false

        // Keep the item if it meets either condition.
        return inAllowedList || inAllowedRange
      })
    }

    return data
  }
}
